import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar } from 'lucide-react';
import { Button } from '../ui/button';
import { fetchBlogPosts } from '../../lib/api';
import { useI18n } from '../../i18n';

const fmtDate = (iso) => iso ? new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '';

const Insights = () => {
  const { t } = useI18n();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetchBlogPosts().then((p) => setPosts((p || []).slice(0, 3))).catch(() => setPosts([]));
  }, []);

  return (
    <section id="insights" className="py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <span className="text-xs font-semibold uppercase tracking-widest text-orange-600">{t('insights.kicker')}</span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900">{t('insights.title')}</h2>
          <p className="mt-4 text-slate-600">{t('insights.body')}</p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((n) => (
            <Link to={`/blog/${n.slug}`} key={n.id} data-testid={`insight-card-${n.slug}`} className="group rounded-2xl overflow-hidden border border-slate-200 bg-white hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300">
              <div className="h-48 overflow-hidden bg-slate-100">
                {n.cover_image && <img src={n.cover_image} alt={n.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />}
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-slate-500">
                  {(n.tags || []).slice(0, 1).map((tag) => (
                    <span key={tag} className="px-2 py-0.5 rounded bg-orange-50 text-orange-600 font-semibold">{tag}</span>
                  ))}
                  <span className="flex items-center gap-1"><Calendar className="h-3.5 w-3.5" /> {fmtDate(n.published_at)}</span>
                </div>
                <h3 className="mt-3 font-bold text-slate-900 group-hover:text-orange-600 transition-colors">{n.title}</h3>
                <p className="mt-2 text-sm text-slate-600 line-clamp-3">{n.excerpt}</p>
                <div className="mt-4 text-sm font-semibold text-orange-600 flex items-center gap-1">
                  {t('common.readArticle')} <ArrowRight className="h-4 w-4" />
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <Link to="/blog" data-testid="view-all-insights-btn">
            <Button variant="outline" className="h-11 px-6 border-slate-300 text-slate-800 hover:bg-slate-100">
              {t('common.viewAllInsights')} <ArrowRight className="h-4 w-4 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Insights;
